module.exports = __webpack_public_path__ + "img/postgres.69107cf8.jpeg";